export default __webpack_public_path__ + "static/media/bellIcon.49e1a951.webp";